import { defineComponent as _defineComponent } from 'vue'
import { roundValue } from '~/functions/ghg'


export default /*#__PURE__*/_defineComponent({
  __name: 'ProgressScore',
  props: {
  percentage: {
    type: Number,
    default: 0,
  },
},
  setup(__props) {



return { __sfc: true,roundValue }
}

})